import React from 'react';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import MoreHorizIcon from 'assets/more_horiz.svg?react';
import { Dropdown } from 'antd';

export interface MenuItem {
  key: string;
  label: string;
  icon: React.ReactNode;
  textColor: string;
  hoverBgColor: string;
  onClick: () => void;
}

interface ItemsMenuProps {
  items: MenuItem[];
  /**
   * Extra class appended to the shared `header-action-buttons-dropdown`
   * overlay class, letting one caller widen/restyle its own menu (e.g.
   * Plans' longer "Create Recommendation" label, FR-035) without touching
   * the fixed 208px width the other three record types' menus also share.
   */
  overlayClassName?: string;
}

const buildDropdownMenuItems = (items: MenuItem[]) => {
  return items.map(item => ({
    key: item.key,
    label: (
      <button
        type="button"
        className="flex items-center px-3 py-2 transition-colors menu-item-container"
        style={{
          color: item.textColor,
          width: '100%',
          cursor: 'pointer',
          border: 'none',
          background: 'transparent',
          textAlign: 'left',
          ['--hover-bg' as string]: item.hoverBgColor
        }}
        onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = item.hoverBgColor;
        }}
        onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        {item.icon && <span className="mr-2">{item.icon}</span>}
        <span>{item.label}</span>
      </button>
    ),
    onClick: item.onClick
  }));
};

const DropdownMenu: React.FC<ItemsMenuProps> = ({
  items,
  overlayClassName
}) => {
  return (
    <Dropdown
      menu={{ items: buildDropdownMenuItems(items) }}
      trigger={['click']}
      placement="bottomRight"
      overlayClassName={`header-action-buttons-dropdown${
        overlayClassName ? ` ${overlayClassName}` : ''
      }`}
    >
      <Button
        type={ButtonType.outline}
        data-testid="more-actions-button"
        aria-label="More actions"
        style={{
          width: '32px',
          height: '32px',
          padding: '0',
          minWidth: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <MoreHorizIcon style={{ width: '18px', height: '18px' }} />
      </Button>
    </Dropdown>
  );
};

export default DropdownMenu;
